import ABCyaLib from '@abcya/abcya_lib';

export default function setupGameConfig(variantId, locale) {
  const config = {
    // add your game config options here, these can be the default values
    delayBetweenTitleVO: 0 // in ms
  };

  switch (locale) {
    case ABCyaLib.Environment.LOCALES.esUS:
      config.delayBetweenTitleVO = 750;
      break;
  }

  return config;
}